import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=1b4bba68&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=1b4bba68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4bba68",
  null
  
)

export default component.exports